module.exports = __webpack_public_path__ + "img/意向转出.6e7084d0.png";